<template>
        <app-layout-profile-page v-if="parent"
                            :item="parent"
                            :hideBottomPanel="true"
                            id="_overlay">
            <template slot="header">
                <v-layout row align-center layout--header>
                    <v-flex class="_flex-avatar">
                        <app-avatar :src="parent.getAvatarUrl()" :color="'success'"></app-avatar>
                        <div class="d-flex _btn-gallery"
                             @click="gallery = true">
                            <app-svg-icon name="brand/NG_IMAGE_GALLERY" width="23" height="18"></app-svg-icon>
                            <span class="px-2">{{parent.images.length}}</span>
                        </div>
                    </v-flex>
                    <v-flex>
                        <h1 class="_mb-xs-only">{{parent.first_name | capitalize}}</h1>
                        <h4 class="">
                            <span class="text-capitalize d-inline-block _mb-xs-only">{{parent.postcode.location | capitalize}}</span>
                        </h4>
                        <p class="text-small text--grey_1 mt-3">Member since {{parent.created_at | formatDate('MMM YYYY')}}</p>
                    </v-flex>
                </v-layout>
            </template>

            <template slot="about">
                <v-layout row wrap>
                    <v-flex xs12 sm9 class="_description">
                        Currently paid up to and including {{parent.subscription.ends_at | formatDate}}
                    </v-flex>
                </v-layout>
            </template>
        </app-layout-profile-page>
</template>

<script>
  import AppBrandshapeBorder from '../../../components/app-brandshape-border'
  import AppLayoutProfilePage from '../../../components/app-layout-profile-page'
  import AppAvatar from '../../../components/app-avatar'
  import AppWindowImageGallery from '../../../components/app-windows/app-window-image-gallery'

  export default {
    name: 'parent-details',

    components: {AppBrandshapeBorder, AppLayoutProfilePage, AppWindowImageGallery, AppAvatar},

    props: ['parentId'],

    data () {
      return {
        parent: null,
        gallery: false
      }
    },
    created () {
      this.$store.dispatch('parents/PARENTS_FIND', this.parentId).then((result) => {
        this.parent = result

        if (!this.parent) {
          this.$router.push('/')
        }
      }).catch(() => {
        this.$router.push('/')
      })
    }
  }
</script>

<style lang="stylus" scoped>
    .layout--header
        margin-top 30px
    ._flex-avatar
        min-width 122px
        max-width 122px
        position relative
        ._btn-gallery
            position absolute
            bottom -18px
            left 40%
            cursor pointer
            opacity .8
            &:hover
                opacity 1
    .app-rating
        display block
    .__wwc-icon
        max-width 80px
    ._mb-xs-only
        margin-bottom 8px
    @media(min-width: 600px)
        ._flex-avatar
            min-width 200px
            max-width 200px
        .app-rating
            display inline-block
        ._mb-xs-only
            margin-bottom 0
        ._description
            padding-right 35px
    @media (min-width: 960px)
        ._flex-avatar
            margin-right 16px
</style>



// WEBPACK FOOTER //
// src/views/app/parents/parent-detail.vue